// shared.module.ts
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FooterModule } from "./_components/footer/footer.module";
import { HeaderModule } from "./_components/header/header.module";
import { SigninWithOtpModule } from "./../auth/_components/signin-with-otp/signin-with-otp.module";
import { ThankYouPageModule } from "./_components/thankyou-modal/thankyou-modal.module";
import { PricingPopupModule } from "./../shared/_components/pricing-popup/pricing-popup.module";

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    HeaderModule,
    FooterModule,
    SigninWithOtpModule,
    ThankYouPageModule,
    PricingPopupModule
  ],
  exports: [
    FooterModule,
    HeaderModule,
    ThankYouPageModule 
  ],
})
export class SharedModule {}
